var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"hb-status-indicator"},[_c('font-awesome-icon',{attrs:{"icon":_vm.statusIcon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }